import { render, staticRenderFns } from "./SettingDisplayTag.vue?vue&type=template&id=b37b7b0e&scoped=true&"
import script from "./SettingDisplayTag.vue?vue&type=script&lang=js&"
export * from "./SettingDisplayTag.vue?vue&type=script&lang=js&"
import style0 from "./SettingDisplayTag.vue?vue&type=style&index=0&id=b37b7b0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b37b7b0e",
  null
  
)

export default component.exports